// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  urlAuth: 'https://sandbox.ente.com.mx:8443/auth/',
  realm: 'ente-escolar',
  clientId: 'backend-alumno',
  urlEndpoint: 'https://sandbox.ente.com.mx:8082/api/',
  channel:'xxxx',
  uriPaciente: 'alumno',
  uriAlumno: 'alumno',
  uriConsulta: 'nip',
  redirectUriKeycloack : '/tabs/tab1',
  onlyCalificacionFinal:true,
  imagesPath:'https://unicarlrogers.com.mx/wp-content/uploads/scholae/foto/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
